/** Le module Node `crypto`, réduit à ce que server.js utilise. */
export const randomUUID = () => globalThis.crypto.randomUUID();

// Ne sert qu'aux logos, qui sont cherchés côté Cloudflare dans la version web.
export function createHash() {
  throw new Error('createHash indisponible dans le navigateur');
}
